import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API });

export const adminApi = () => {
  const token = localStorage.getItem("sv_admin_token") || "";
  return axios.create({
    baseURL: API,
    headers: { "X-Admin-Key": token },
  });
};

export const fmtAUD = (n) =>
  new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD", maximumFractionDigits: 0 }).format(n);
